import {
  Flame,
  Bath,
  Thermometer,
  ShowerHead,
  Car,
  Sparkles,
  UtensilsCrossed,
  Utensils,
  Telescope,
  Recycle,
  Film,
  ChefHat,
  Stars,
  Leaf,
  TreePine,
  Coffee,
  Wifi,
  Bike,
} from "lucide-react";

// Single source of truth for service/feature icons used across:
// - Home features grid     (HomePage.jsx)
// - Booking add-on picker  (BookingPage.jsx)
// - Admin features tab     (admin/tabs.jsx)
//
// Each entry has a Lucide component + an English/Mongolian default label
// so admins can quickly pick a service from the icon picker.

export const FEATURE_ICONS = [
  // -- Existing keys (kept for backwards compatibility with seeded data) --
  { key: "flame",          icon: Flame,           label_en: "Bonfire",                label_mn: "Задгай гал" },
  { key: "bath",           icon: Bath,            label_en: "Hot bathtub",            label_mn: "Халуун усан сан" },
  { key: "thermometer",    icon: Thermometer,     label_en: "Sauna",                  label_mn: "Саун" },
  { key: "shower-head",    icon: ShowerHead,      label_en: "Shower",                 label_mn: "Шүршүүр" },
  { key: "car",            icon: Car,             label_en: "Delivery car",           label_mn: "Хүргэлтийн машин" },
  { key: "sparkles",       icon: Sparkles,        label_en: "Extra service",          label_mn: "Нэмэлт үйлчилгээ" },

  // -- Newly requested service icons --
  { key: "fire-pit",       icon: Flame,           label_en: "Private fire pit",       label_mn: "Хувийн зуухтай гал" },
  { key: "hot-tub",        icon: Bath,            label_en: "Outdoor hot tub",        label_mn: "Гадаа халуун усан сан" },
  { key: "bbq",            icon: UtensilsCrossed, label_en: "BBQ & outdoor kitchen",  label_mn: "Шарлага ба гадаа гал тогоо" },
  { key: "picnic",         icon: Utensils,        label_en: "Picnic & dining zone",   label_mn: "Пикник, хоолны зориулсан газар" },
  { key: "stargazing",     icon: Telescope,       label_en: "Stargazing session",     label_mn: "Од хармалзах цаг" },
  { key: "eco-sanitation", icon: Recycle,         label_en: "Eco-friendly sanitation", label_mn: "Эко-найрсаг ариун цэвэр" },
  { key: "outdoor-shower", icon: ShowerHead,      label_en: "Outdoor shower",         label_mn: "Гадаа шүршүүр" },
  { key: "cinema",         icon: Film,            label_en: "Outdoor cinema",         label_mn: "Гадаа кино театр" },

  // -- A few extras admins commonly need (small, free, easy to ignore) --
  { key: "chef",           icon: ChefHat,         label_en: "Private chef",           label_mn: "Хувийн тогооч" },
  { key: "stars",          icon: Stars,           label_en: "Night activities",       label_mn: "Шөнийн арга хэмжээ" },
  { key: "leaf",           icon: Leaf,            label_en: "Eco extra",              label_mn: "Эко нэмэлт" },
  { key: "tree",           icon: TreePine,        label_en: "Nature trail",           label_mn: "Байгалийн зам" },
  { key: "coffee",         icon: Coffee,          label_en: "Morning coffee",         label_mn: "Өглөөний кофе" },
  { key: "wifi",           icon: Wifi,            label_en: "Wi-Fi",                  label_mn: "Утасгүй интернэт" },
  { key: "bike",           icon: Bike,            label_en: "Bike rental",            label_mn: "Унадаг дугуй түрээс" },
];

// Quick lookup: key → Lucide component
export const FEATURE_ICON_MAP = FEATURE_ICONS.reduce((acc, f) => {
  acc[f.key] = f.icon;
  return acc;
}, {});

// Helper used by public-side renderers
export function getFeatureIcon(key) {
  return FEATURE_ICON_MAP[key] || Sparkles;
}
